
export default [{
  path: '/wx/bind',
  meta: {
    title: '登录'
  },
  component: () => import('../views/page/wx_service/bind.vue')
}, {
    path: '/wx/sync_wxuserinfo',
  meta: {
    title: '登录'
  },
  component: () => import('../views/page/wx_service/sync_wxuserinfo.vue')
}, {
    path: '/wx/account_status',
  meta: {
    title: '登录'
  },
  component: () => import('../views/page/wx_service/account_status.vue')
}]
